(function () {
    "use strict";

    angular
        .module("iMatApp")
        .factory("modelFilePreviewService", modelFilePreviewService);

    modelFilePreviewService.$inject = ["$http", "$q", "$timeout", "processingWorkflowService"];

    function modelFilePreviewService($http, $q, $timeout, processingWorkflowService) {
        var RETRY_COUNT = 6;
        var RETRY_WAIT = 1000;

        var previewTypes = {
            thumbnail: "thumbnail",
            stripe: "stripe",
            threeD: "threeD"
        };

        return {
            get3DPreviewInfo: get3DPreviewInfo,
            getStripePreviewInfo: getStripePreviewInfo,
            getThumbnailPreviewInfo: getThumbnailPreviewInfo
        };

        function get3DPreviewInfo(modelId, canceler, waitResults) {
            return getPreviewInfo(
                modelId,
                previewTypes.threeD,
                canceler,
                waitResults
            );
        }

        function getStripePreviewInfo(modelId, canceler, waitResults) {
            return getPreviewInfo(
                modelId,
                previewTypes.stripe,
                canceler,
                waitResults
            );
        }

        function getThumbnailPreviewInfo(modelId, canceler, waitResults) {
            return getPreviewInfo(
                modelId,
                previewTypes.thumbnail,
                canceler,
                waitResults
            );
        }

        // Generate preview command will be sent when preview not found
        // and waiting results(by default) of generation preview.
        function getPreviewInfo(modelId, previewType, canceler, waitResults) {
            waitResults = waitResults !== false;

            return sendGetPreviewInfoRequest(modelId, previewType, canceler).catch(
                function (response) {
                    if (response.status !== 404) {
                        return null;
                    }

                    var flow = sendStartGeneratePreviewRequest(modelId, previewType, canceler);

                    if (waitResults) {
                        flow = flow
                            .then(function (workflowId) {
                                return processingWorkflowService.waitProcessingWorkflowComplete(workflowId, canceler);
                            })
                            .then(function () {
                                return tryGetPreviewInfo(modelId, previewType, canceler);
                            });
                    }

                    return flow;
                }
            );
        }

        function tryGetPreviewInfo(modelId, previewType, canceler, retryCount) {
          
            retryCount = retryCount || 1;

            return sendGetPreviewInfoRequest(modelId, previewType, canceler)
                .catch(function (response) {
                    if (response && response.status === 404 && retryCount < RETRY_COUNT) {
                        return "retry";
                    }
                    
                    return $q.reject(response);
                }).then(function (result) {
                    
                    if (result === "retry") {
                        return $timeout(RETRY_WAIT)
                            .then(function () {
                                return tryGetPreviewInfo(modelId, previewType, canceler, retryCount + 1);
                            });
                    }

                    return result;
                });
        }

        function sendGetPreviewInfoRequest(modelId, previewType, canceler) {
            return $http
                .get("/models/" + modelId + "/preview-info/" + previewType, {
                    canceler: canceler
                })
                .then(function (response) {
                    return response.data;
                });
        }

        function sendStartGeneratePreviewRequest(modelId, previewType, canceler) {
            return $http
                .post("/models/" + modelId + "/generate-preview/" + previewType, null, {
                    canceler: canceler
                })
                .then(function (response) {
                    return response.data;
                });
        }
    }
})();
